<template>
    <div class="border-bottom py-4">
        <v-layout v-if="content.time" wrap class="pb-3">
            {{ content.time.split(" ")[0] }}
            <div class="grey-text ml-2 mr-4"> {{ content.time.split(" ")[1] }}</div>

            <router-link v-if="content.user" :to="{name: 'profile_other', params: {id: content.user.id}}" class="flex ideas-item__user md4 xs12">
                <!-- <v-flex class="ideas-item__user"
                        md4 xs12
                > -->
                <div v-if="content.user.avatar" class="ideas-item__user-avatar">
                    <img :src="content.user.avatar" alt="avatar" style="max-width: 80px;max-height: 80px;">
                </div>
                <v-layout align-start>
                    <span class="grey-text">{{ content.user.name }}</span>
                </v-layout>
                <!-- </v-flex> -->
            </router-link>
        </v-layout>

        <v-layout>
            {{ content.message }}
        </v-layout>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    content: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('live_news', [
      'live_news',
    ]),
  },
  methods: {
    day(date) {
      return new dayjs(date).format('DD.MM.YYYY');
    },
    time(date) {
      return new dayjs(date).format('HH.mm');
    },
  },
};
</script>

